import { getUserList } from '../services/Masters/MatersService';
import { useMenu } from '../context/MenuContext';
import { fetchUserRights } from '../apis/UserRights';

export const fetchUsers = async (status) => {
  try {
    const response = await getUserList(status);

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching users list',
        variant: 'error'
      });
      console.log('Error fetching users list:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching users list',
      variant: 'error'
    });
    console.log('Error fetching users list:', err);
    return [];
  }
};

export const fetchRights = async (userRole) => {
  try {
    const response = await fetchUserRights(userRole);
    return response || [];
  } catch (err) {
    console.log('Error fetching user rights:', err);
    return [];
  }
};
